import uniqid from 'uniqid';

export const card = (symbol, code) => ({
  id: uniqid(),
  symbol,
  value: code,
  flipped: false,
  matched: false
});

export const cardDetailed = (details, code) => ({
  id: uniqid(),
  symbol: details.value,
  value: code,
  color: details.color,
  backgroundColor: details.backgroundColor,
  image: details.image,
  font: details.font,
  flipped: false,
  matched: false
});

export const cardImage = (details, code) => ({
  id: uniqid(),
  value: code,
  image: details.image,
  vocal: details.vocal,
  flipped: false,
  matched: false
});
